import { Visibility } from '@mui/icons-material';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import moment from 'moment';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import { HttpClient } from 'src/Helpers/http/http';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import DeleteConfirmation from 'src/Utils/DeleteConfirmation';
import { Link } from 'react-router-dom';
import { TOtherIncomeList } from './type/otherIncomeType';
import PopoverComponent from 'src/common/PopoverComponent';
import DeleteDataApi from 'src/common/FetchData/DeleteDataApi';

type IProps = {
  inComeData: TOtherIncomeList;
  index: number;
  isSuccessFun?: () => void;
};
const OtherIncomeTableRow = ({ inComeData, index, isSuccessFun }: IProps) => {
  const {
    cheque_no,
    amount,
    method,
    account_name,
    id,
    voucher_no,
    bank_name,
    income_no,
    income_date,
  } = inComeData || {};
  const theme = useTheme();
  const { deleteData, success } = DeleteDataApi(`/api/atab/income`);
  useEffect(() => {
    if (success) {
      isSuccessFun();
    }
  }, [success]);

  return (
    <TableRow hover>
      <TableCell>{index}</TableCell>
      <TableCell>{income_no}</TableCell>
      <TableCell>{voucher_no}</TableCell>
      <TableCell>{moment(income_date).format('DD-MM-YYYY')}</TableCell>
      <TableCell>{method}</TableCell>
      <TableCell>{account_name}</TableCell>
      <TableCell>{amount}</TableCell>
      <TableCell>
        <Tooltip title='View' arrow>
          <Link to={`${id}`}>
            <IconButton
              sx={{
                '&:hover': {
                  background: theme.colors.primary.lighter,
                },
                color: theme.palette.primary.main,
              }}
              color='inherit'
              size='small'
            >
              <Visibility fontSize='small' />
            </IconButton>
          </Link>
        </Tooltip>
        <Tooltip title='Delete expense' arrow>
          <PopoverComponent
            children={<DeleteTwoToneIcon fontSize='small' color='error' />}
            popOverTitle='Are you sure to delete'
            handleConfirm={() => deleteData(`${id}?CompanyProfileId=1`)}
          />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default OtherIncomeTableRow;
